module.exports = __webpack_public_path__ + "static/media/Disbursed-Funds.7ed9aca2.svg";